import React, {FC} from 'react'
import '../../css/widgets/RadioButton.scss'

interface RadioButtonProps {
  name: string
  value: number
  checked: boolean
  action: (e:any) => void
  unit: string
}

const RadioButton:FC<RadioButtonProps> = ({ name, value, checked, action, unit }) => {
  return (
    <span className="radio-button">
        <input
          className="radio"
          type="radio"
          name={name}
          id={'toggle-' + value}
          value={value}
          onChange={action}
          checked={checked}
        />
        <label htmlFor={'toggle-' + value}>
          {' '}
          {value} <span className="unit">{unit}</span>
        </label>
      </span>
  )
}

export default RadioButton
